'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DocumentKind$() {
  this.c6Z = null;
  this.c70 = false;
}
export { $c_Lpresto_types$DocumentKind$ as $c_Lpresto_types$DocumentKind$ };
$p = $c_Lpresto_types$DocumentKind$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DocumentKind$;
/** @constructor */
function $h_Lpresto_types$DocumentKind$() {
}
export { $h_Lpresto_types$DocumentKind$ as $h_Lpresto_types$DocumentKind$ };
$h_Lpresto_types$DocumentKind$.prototype = $p;
$p.ae5 = (function() {
  if ((!this.c70)) {
    this.c6Z = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c70 = true;
  }
  return this.c6Z;
});
var $d_Lpresto_types$DocumentKind$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DocumentKind$, "presto.types$DocumentKind$", ({
  ZV: 1,
  D: 1
}));
export { $d_Lpresto_types$DocumentKind$ as $d_Lpresto_types$DocumentKind$ };
var $n_Lpresto_types$DocumentKind$;
function $m_Lpresto_types$DocumentKind$() {
  if ((!$n_Lpresto_types$DocumentKind$)) {
    $n_Lpresto_types$DocumentKind$ = new $c_Lpresto_types$DocumentKind$();
  }
  return $n_Lpresto_types$DocumentKind$;
}
export { $m_Lpresto_types$DocumentKind$ as $m_Lpresto_types$DocumentKind$ };
//# sourceMappingURL=presto.types$-Document-Kind$.js.map
